// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "promo__icon-1qpkC";
export { _1 as "__esModule", _2 as "promo__icon" }
export default { "__esModule": _1, "promo__icon": _2 }
